import React from "react";
import { Form, Label } from "semantic-ui-react";

const TextArea = ({
  input,
  rows,
  width,
  type,
  label,
  placeholder,
  defaultValue,
  meta: { touched, error }
}) => {
  return (
    <Form.Field error={touched && !!error}>
      <label>{label}</label>
      <textarea
        {...input}
        placeholder={placeholder}
        type={type}
        rows={rows}
        value={input.value || defaultValue || ""}
      />
      {touched && error && (
        <Label basic color='red'>
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default TextArea;
